module.exports = __webpack_public_path__ + "img/ctrl-gluINT.66af8b3d.png";